import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Network as NetIcon } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@vnetwork/ui/primitives';
import { PrivateNetworks } from './networking/PrivateNetworks';
import { ReservedNetworks } from './networking/ReservedNetworks';
import { VirtualRouters } from './networking/VirtualRouters';

type Tab = 'private' | 'reserved' | 'routers';
const TABS: { key: Tab; label: string }[] = [
  { key: 'private', label: 'Private networks' },
  { key: 'reserved', label: 'Reserved networks' },
  { key: 'routers', label: 'Virtual routers' },
];

export function Networking() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const [tab, setTab] = useState<Tab>('private');

  return (
    <Container size="xl">
      <PageHeader icon={<NetIcon size={22} />} title="Networking" description="Private and reserved networks, and virtual routers." />
      <Tabs value={tab} onValueChange={(v) => setTab(v as Tab)}>
        <TabsList>
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key}>{t.label}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="private"><PrivateNetworks serviceId={serviceId!} /></TabsContent>
        <TabsContent value="reserved"><ReservedNetworks serviceId={serviceId!} /></TabsContent>
        <TabsContent value="routers"><VirtualRouters serviceId={serviceId!} /></TabsContent>
      </Tabs>
    </Container>
  );
}
